export default __webpack_public_path__ + "static/media/logo.ca0a94e3.png";